'use client'

import { CatalogMain } from '@/screens/CatalogMain'

import { CatalogItem } from '@/entities/catalog/types'

type Props = {
	catalogItems: CatalogItem[]
}

const CatalogMainPageContent = ({ catalogItems }: { catalogItems: CatalogItem[] }) => {
	return <CatalogMain catalogItems={catalogItems} />
}

export function CatalogMainClient({ catalogItems }: Props) {
	return <CatalogMainPageContent catalogItems={catalogItems} />
}
